import type { QuickRaceSelection, RaceResult } from "../types";

export const RACE_COUNTDOWN_MS = 3_000;
export const GO_CUE_MS = 650;

export function countdownCue(elapsedMilliseconds: number): "3" | "2" | "1" | "GO" | null {
  if (elapsedMilliseconds < 0) return "3";
  if (elapsedMilliseconds < 1_000) return "3";
  if (elapsedMilliseconds < 2_000) return "2";
  if (elapsedMilliseconds < RACE_COUNTDOWN_MS) return "1";
  if (elapsedMilliseconds < RACE_COUNTDOWN_MS + GO_CUE_MS) return "GO";
  return null;
}

export function raceHasStarted(elapsedMilliseconds: number): boolean {
  return elapsedMilliseconds >= RACE_COUNTDOWN_MS;
}

export function exactRematchSelection(selection: QuickRaceSelection): QuickRaceSelection {
  return structuredClone(selection);
}

export function finishCue(results: RaceResult[]): { kicker: string; headline: string; detail: string } {
  const winner = results.find((result) => result.status === "FINISHED");
  const humanIndex = results.findIndex((result) => result.driverId === "human");
  const human = humanIndex >= 0 ? results[humanIndex] : null;
  const detail = human
    ? human.status === "FINISHED"
      ? `DIG · PLADS ${humanIndex + 1} · ${human.finishTime?.toFixed(2) ?? "—"} s`
      : `DIG · PLADS ${humanIndex + 1} · UDGÅET`
    : winner?.finishTime === null || winner?.finishTime === undefined
      ? "Endelig stilling"
      : `${winner.finishTime.toFixed(2)} s`;
  return winner
    ? { kicker: "MÅLFLAG", headline: `${winner.displayName} vinder!`, detail }
    : { kicker: "LØBET ER SLUT", headline: "Endelig stilling", detail };
}
